import { inject, Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';
import { _, TranslateService } from '@ngx-translate/core';
import { MessageConfigsService } from '@app/core/services/message-configs/message-configs.service';
import { ToastSeverity } from '@app/shared/components/toast-content/toast-content.component';
import { ILocalizationKey } from '@app/core/interfaces/localization';

@Injectable({
  providedIn: 'root',
})
export class ClipboardCopyService {
  private readonly clipboard = inject(Clipboard);
  private readonly messageService = inject(MessageService);
  private readonly messageConfigsService = inject(MessageConfigsService);
  private readonly translateService = inject(TranslateService);

  public copy(
    value: string | number | boolean | null | undefined,
    toastMessageKey: ILocalizationKey = _(`@@shared-toast__copied-to-clipboard`)
  ) {
    if (value === undefined || value === null || value === '') return;

    this.clipboard.copy(String(value));
    this.messageService.add({
      ...this.messageConfigsService.getMainContentMessageConfig(),
      severity: ToastSeverity.Success,
      summary: this.translateService.instant(toastMessageKey),
    });
  }
}
